import React from 'react'

const Challenge = () => {
  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
          >
            A leading Australian media company struggled with delayed campaign performance insights that prevented
            advertisers from making timely optimization decisions. Their legacy analytics system processed data in batches,
            creating hours-long delays between campaign events and performance reporting. Manual report generation consumed
            excessive analyst time, campaigns couldn't be monitored during peak hours due to system limitations, and the
            inability to handle high-volume data streams meant missing critical advertising opportunities during major events
            and product launches.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li>Processing millions of advertising events daily without performance degradation or data loss</li>
            <li>Real-time dashboard updates requiring sub-second latency for impressions, clicks, conversions, and ROI metrics</li>
            <li>High-volume data streams during peak advertising periods (holiday seasons, major events) overwhelming existing infrastructure</li>
            <li>Manual reporting process consuming 50% of analyst time and delaying strategic decisions</li>
            <li>Need for customized reports tailored to diverse client KPIs and reporting timeframes</li>
            <li>Inability to track campaign performance across multiple channels in unified view</li>
            <li>Integration requirements with various ad networks, social media platforms, and analytics tools</li>
            <li>Scalability challenges requiring AWS cloud infrastructure with message queuing for reliability</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
